import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import {
  DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
  DOCUMENT_TYPES_MARRIAGE_CONTRACT,
  DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
  DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  MARITAL_STATUS_MARRIED,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import isFileSizeSmallerThan from '../../../../utils/validateFileSize';

const NotarialDocuments = ({
  backHandler,
  loading,
  deal,
  documents,
  chosenBankAppealId,
  setLoading,
  onSuccess,
  bankId,
  preferentialLoan,
}) => {
  const { uploadMultiple, uploading, progress, currentFileName, uploadQueue } = useDocumentUpload();
  const maritalStatus = deal?.creditAppeal?.maritalStatus;
  const isMarried = maritalStatus === MARITAL_STATUS_MARRIED;

  const onNotarialDocumentsSubmit = async (values) => {
    const hasMarriageContract = Boolean(values['Брачный контракт']);
    const hasSpouseConsent = Boolean(values['согласие']);
    const hasExtrajudicialEnforcement = Boolean(values['Заявление на внесудебную реализацию авто']);

    if (isMarried && !preferentialLoan) {
      if (hasMarriageContract && !hasExtrajudicialEnforcement) {
        alert.error('Для клиента с брачным контрактом необходимо загрузить заявление на внесудебную реализацию авто');
        return;
      }

      if (!hasMarriageContract && !hasSpouseConsent) {
        alert.error('Необходимо загрузить согласие супруга (супруги) на внесудебную реализацию авто');
        return;
      }
    }

    // if (preferentialLoan) {
    //   if (!values['originCertificate']) {
    //     alert.error('Необходимо загрузить сертификат о происхождении товара');
    //     return;
    //   }
    // }

    if (hasSpouseConsent && !isFileSizeSmallerThan(values['согласие'], 10)) {
      alert.error('Размер файла согласия супруга (супруги) не должен превышать 10 МБ');
      return;
    }

    const filesToUpload = [
      values['согласие'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_SPOUSE_CONSENT, file: values['согласие'] },
      values['доверенность'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        file: values['доверенность'],
      },
      values['Заявление на внесудебную реализацию авто'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE,
        file: values['Заявление на внесудебную реализацию авто'],
      },
      values['Брачный контракт'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_MARRIAGE_CONTRACT,
        file: values['Брачный контракт'],
      },
      values['originCertificate'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
        file: values['originCertificate'],
      },
      // values['customsClearanceConfirmation'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION, file: values['customsClearanceConfirmation'] },
      // values['extendedProducerResponsibilityConfirmation'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION, file: values['extendedProducerResponsibilityConfirmation'] },
    ].filter(Boolean);

    try {
      await uploadMultiple(filesToUpload);
      setLoading(true);
      onSuccess(values);
    } catch (err) {
      alert.error('Ошибка загрузки документов');
      setLoading(false);
    }
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} queue={uploadQueue} />;
  }

  return (
    <div>
      <HookForm
        title={'Документы'}
        hint="Проконсультируйте клиента какие именно доверенности и согласия надо сделать. Нужно чтобы клиент запрашивал равнозначность доверенности, это необходимо для того, чтобы можно было выписать доверенность у любого нотариуса.   Так же нужно описать на кого нужно сделать доверенность на постановку на учет. Выписать доверенность на регистрационные действия нужно на ФИО, ИИН человека."
        grid={{ display: 'grid', gap: 20 }}
        action={'Сохранить и продолжить'}
        inputs={[
          {
            text: 'Согласие супруга (супруги) на внесудебную реализацию авто',
            label: 'Загрузить документ',
            name: 'согласие',
            id: 'Согласие супруга (супруги) на внесудебную реализацию авто',
            component: DocsInputNew,
            rules: {
              deps: ['Брачный контракт'],
              validate: (value, getValues) => {
                if(!preferentialLoan) return true;
                if (!isMarried) {
                  return true;
                }

                const marriageContract = getValues('Брачный контракт');
                if (!marriageContract && !value) {
                  return 'Загрузите согласие супруга (супруги) или брачный контракт';
                }

                return true;
              },
            },
          },
          {
            text: 'Заявление на внесудебную реализацию авто',
            label: 'Загрузить документ',
            name: 'Заявление на внесудебную реализацию авто',
            id: 'Заявление на внесудебную реализацию авто',
            component: DocsInputNew,
            rules: {
              deps: ['Брачный контракт'],
              validate: (value, getValues) => {
                if (!isMarried) {
                  return true;
                }

                const marriageContract = getValues('Брачный контракт');
                if (marriageContract && !value) {
                  return 'При наличии брачного контракта загрузите заявление на внесудебную реализацию авто';
                }

                return true;
              },
            },
          },
          {
            text: 'Брачный контракт',
            label: 'Загрузить документ',
            name: 'Брачный контракт',
            id: 'Брачный контракт',
            component: DocsInputNew,
          },
          {
            text: 'Доверенность постановки на учет',
            label: 'Загрузить документ',
            name: 'доверенность',
            id: 'Доверенность постановки на учет',
            component: DocsInputNew,
          },
          {
            text: 'Сертификат о происхождении товара (форма СТ-KZ) для авто отечественного производства до 2025г выпуска  или Одобрение типа транспортного средства (ОТТС) для авто отечественного производства, начиная с 2026г выпуска',
            label: 'Загрузить документ',
            name: 'originCertificate',
            id: 'originCertificate',
            component: DocsInputNew,
            // required: preferentialLoan,
          },
          // {
          //   text: 'Документ подтверждающий прохождение таможенного оформления',
          //   label: 'Загрузить документ',
          //   name: 'customsClearanceConfirmation',
          //   id: 'Документ подтверждающий прохождение таможенного оформления',
          //   component: DocsInputNew,
          // },
          // {
          //   text: 'Документ подтверждающий исполнение расширенных обязательств производителями (импортерами)',
          //   label: 'Загрузить документ',
          //   name: 'extendedProducerResponsibilityConfirmation',
          //   id: 'Документ подтверждающий исполнение расширенных обязательств производителями (импортерами)',
          //   component: DocsInputNew,
          // },
          {
            label: 'Номер доверенности',
            name: 'powerOfAttorneyNumber',
          },
        ]}
        onSubmit={onNotarialDocumentsSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default NotarialDocuments;
